var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"draw-message-input q-field__native",domProps:{"value":_vm.layer.sharedMessage},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }